export default __webpack_public_path__ + "static/media/join-contest.33b8692b.mp4";